import Vue from 'vue'
import VueRouter from 'vue-router'
import form from '../views/form.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: {
      name: 'form'
    }
  },
  {
    path: '/form',
    name: 'form',
    component: form
  },
  {
    path: '/formInput',
    name: 'formInput',
    component: () => import(/* webpackChunkName: "formInput" */ '../views/formInput.vue')
  },
  {
    path: '/app_error',
    name: 'app_error',
    component: () => import(/* webpackChunkName: "formInput" */ '../views/app_error.vue')
  },
  {
    path: '/test',
    name: 'test',
    component: () => import(/* webpackChunkName: "test" */ '../views/test.vue')
  },
  {
    path: '/handleForm',
    name: 'handleForm',
    component: () => import(/* webpackChunkName: "handleForm" */ '../views/handleForm.vue')
  },
  {
    path: '/handleFormWrapper',
    name: 'handleFormWrapper',
    component: () => import(/* webpackChunkName: "handleFormWrapper" */ '../views/handleFormWrapper.vue')
  },
  {
    path: '/formData',
    name: 'formData',
    component: () => import(/* webpackChunkName: "formData" */ '../views/formData.vue')
  },
  {
    path: '/formDataDetail',
    name: 'formDataDetail',
    component: () => import(/* webpackChunkName: "formDataDetail" */ '../views/formDataDetail.vue')
  },
  {
    path: '/formViewDataDetail',
    name: 'formViewDataDetail',
    component: () => import(/* webpackChunkName: "formViewDataDetail" */ '../views/formViewDataDetail.vue')
  },
  {
    path: '/formPreview',
    name: 'formPreview',
    component: () => import(/* webpackChunkName: "formPreview" */ '../views/formPreview.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/login.vue')
  },
  {
    path: '/tempLogin',
    name: 'tempLogin',
    component: () => import(/* webpackChunkName: "tempLogin" */ '../views/tempLogin.vue')
  },
  {
    path: '/invite',
    name: 'invite',
    component: () => import(/* webpackChunkName: "invite" */ '../views/invite.vue')
  },
  {
    path: '/member',
    name: 'member',
    component: () => import(/* webpackChunkName: "member" */ '../views/member.vue')
  },
  {
    path: '/dep',
    name: 'dep',
    component: () => import(/* webpackChunkName: "dep" */ '../views/dep.vue')
  },
  {
    path: '/link/invite_router',
    name: 'linkInviteRouter',
    component: () => import(/* webpackChunkName: "linkInviteRouter" */ '../views/link/invite_router.vue')
  },
  {
    path: '/link/posting',
    name: 'linkPosting',
    meta: {
      title: '外链填写'
    },
    component: () => import(/* webpackChunkName: "linkPosting" */ '../views/link/posting.vue')
  },
  {
    path: '/link/query',
    name: 'linkQuery',
    meta: {
      title: '外链查询'
    },
    component: () => import(/* webpackChunkName: "linkQuery" */ '../views/link/query.vue')
  },
  {
    path: '/teamApply',
    name: 'teamApply',
    meta: {
      title: '成员申请'
    },
    component: () => import(/* webpackChunkName: "teamApply" */ '../views/teamApply.vue')
  },
  {
    path: '/setPermission',
    name: 'setPermission',
    meta: {
      title: '分配权限'
    },
    component: () => import(/* webpackChunkName: "teamApply" */ '../views/setPermission.vue')
  },
  {
    path: '/createTeam',
    name: 'createTeam',
    meta: {
      title: '创建团队'
    },
    component: () => import(/* webpackChunkName: "createTeam" */ '../views/createTeam.vue')
  },
  {
    path: '/appDes',
    name: 'appDes',
    component: () => import(/* webpackChunkName: "appDes" */ '../views/appDes.vue')
  },
  {
    path: '/applyList',
    name: 'applyList',
    component: () => import(/* webpackChunkName: "applyList" */ '../views/applyList.vue')
  },
  {
    path: '/upload_image',
    name: 'uploadImage',
    component: () => import(/* webpackChunkName: "uploadImage" */ '../views/upload_image.vue')
  },
  {
    path: '/recommend/recomTemplate',
    name: 'recomTemplate',
    component: () => import(/* webpackChunkName: "recomTemplate" */ '../views/recommend/recomTemplate.vue')
  },
  {
    path: '/recommend/recomTag',
    name: 'recomTag',
    component: () => import(/* webpackChunkName: "recomTag" */ '../views/recommend/recomTag.vue')
  },
  {
    path: '/tc/templateList',
    name: 'templateList',
    meta: {
      title: '应用中心'
    },
    component: () => import(/* webpackChunkName: "templateList" */ '../views/tc/templateList.vue')
  },
  {
    path: '/tc/tempPreview',
    name: 'tempPreview',
    component: () => import(/* webpackChunkName: "tempPreview" */ '../views/tc/tempPreview.vue')
  },
  {
    path: '/tc/tempFormPreview',
    name: 'tempFormPreview',
    component: () => import(/* webpackChunkName: "tempFormPreview" */ '../views/tc/tempFormPreview.vue')
  },
  {
    path: '/tc/tempDashPreview',
    name: 'tempDashPreview',
    component: () => import(/* webpackChunkName: "tempDashPreview" */ '../views/tc/tempDashPreview.vue')
  },
  {
    path: '/tc/installTemp',
    name: 'installTemp',
    component: () => import(/* webpackChunkName: "installTemp" */ '../views/tc/installTemp.vue')
  },
  {
    path: '/tc/templateDes',
    name: 'templateDes',
    component: () => import(/* webpackChunkName: "templateDes" */ '../views/tc/templateDes.vue')
  },
  {
    path: '/home',
    name: 'homeIndex',
    redirect: '/home/apps',
    component: () => import(/* webpackChunkName: "homeIndex" */ '../views/home/index.vue'),
    children: [
      {
        path: '/home/apps',
        name: 'homeApps',
        component: () => import(/* webpackChunkName: "homeApps" */ '../views/home/apps.vue')
      },
      {
        path: '/home/workStation',
        name: 'homeWorkStation',
        meta: {
          title: '工作台'
        },
        component: () => import(/* webpackChunkName: "homeWorkStation" */ '../views/home/workStation.vue')
      },
      {
        path: '/home/mix_form',
        name: 'homeMixForm',
        component: () => import(/* webpackChunkName: "homeMixForm" */ '../views/mix_form/index.vue')
      },
      {
        path: '/home/mine',
        name: 'homeMine',
        meta: {
          title: '更多'
        },
        component: () => import(/* webpackChunkName: "homeMine" */ '../views/home/mine.vue')
      }
    ]
  },
  {
    path: '/3rd_router',
    name: '3rdRouter',
    component: () => import(/* webpackChunkName: "3rdRouter" */ '../views/3rd_router.vue')
  },
  {
    path: '/app/index',
    name: 'appHome',
    component: () => import(/* webpackChunkName: "appHome" */ '../views/app/index.vue'),
    children: [
      {
        path: '/app/fillForm',
        name: 'appFillForm',
        component: () => import(/* webpackChunkName: "appFillForm" */ '../views/app/fillForm.vue')
      },
      {
        path: '/app/dashboard',
        name: 'appDashboard',
        component: () => import(/* webpackChunkName: "appDashboard" */ '../views/app/dashboard.vue')
      },
      {
        path: '/app/forms',
        name: 'appForms',
        component: () => import(/* webpackChunkName: "appForms" */ '../views/app/forms.vue')
      },
      {
        path: '/app/flowTodo',
        name: 'appFlowTodo',
        component: () => import(/* webpackChunkName: "appFlowTodo" */ '../views/app/flowTodo.vue')
      },
      {
        path: '/app/common',
        name: 'appCommon',
        component: () => import(/* webpackChunkName: "appCommon" */ '../views/app/common.vue')
      },
      {
        path: '/app/dataView',
        name: 'appDataView',
        component: () => import(/* webpackChunkName: "appDataView" */ '../views/app/dataView.vue')
      },
    ]
  },
  {
    path: '/app_preview/index',
    name: 'appPreview',
    component: () => import(/* webpackChunkName: "appPreview" */ '../views/app_preview/index'),
    children: [
      {
        path: '/app_preview/fillForm',
        name: 'appPreviewFillForm',
        component: () => import(/* webpackChunkName: "appPreviewFillForm" */ '../views/app_preview/fillForm.vue')
      },
      {
        path: '/app_preview/dashboard',
        name: 'appPreviewDashboard',
        component: () => import(/* webpackChunkName: "appPreviewDashboard" */ '../views/app_preview/dashboard.vue')
      },
      {
        path: '/app_preview/forms',
        name: 'appPreviewForms',
        component: () => import(/* webpackChunkName: "appPreviewForms" */ '../views/app_preview/forms.vue')
      },
      {
        path: '/app_preview/flowTodo',
        name: 'appPreviewFlowTodo',
        component: () => import(/* webpackChunkName: "appPreviewFlowTodo" */ '../views/app_preview/flowTodo.vue')
      },
      {
        path: '/app_preview/common',
        name: 'appPreviewCommon',
        component: () => import(/* webpackChunkName: "appPreviewCommon" */ '../views/app_preview/common.vue')
      },
    ]
  },
  {
    path: '/form/flowManage',
    name: 'formFlowManage',
    meta: {
      title: '流程管理'
    },
    component: () => import(/* webpackChunkName: "formFlowManage" */ '../views/form/flowManage.vue')
  },
  {
    path: '/sign',
    name: 'sign',
    meta: {
      title: '签名'
    },
    component: () => import(/* webpackChunkName: "sign" */ '../views/sign.vue')
  },
  {
    path: '/print_result',
    name: 'printResult',
    component: () => import(/* webpackChunkName: "printResult" */ '../views/print_result.vue')
  },
  {
    path: '/link/formInstanceData',
    name: 'formInstanceData',
    component: () => import(/* webpackChunkName: "formInstanceData" */ '../views/link/formInstanceData.vue')
  },

  {
    path: '/space',
    name: 'space',
    component: () => import(/* webpackChunkName: "space" */ '../views/space.vue')
  },
  {
    path: '/home3rd/:spaceId',
    name: 'home3rdIndex',
    component: () => import(/* webpackChunkName: "home3rdIndex" */ '../views/home3rd/index.vue'),
    children: [
      {
        path: '/home3rd/:spaceId/mine/:pageConfigId',
        name: 'home3rdMine',
        component: () => import(/* webpackChunkName: "home3rdMine" */ '../views/home3rd/mine.vue')
      },
      {
        path: '/home3rd/:spaceId/fillForm/:pageConfigId',
        name: 'home3rdFillForm',
        component: () => import(/* webpackChunkName: "home3rdFillForm" */ '../views/home3rd/fillForm.vue')
      },
      {
        path: '/home3rd/:spaceId/todoTask/:pageConfigId',
        name: 'home3rdTodoTask',
        component: () => import(/* webpackChunkName: "home3rdTodoTask" */ '../views/home3rd/todoTask.vue')
      },
      {
        path: '/home3rd/:spaceId/formDetail/:pageConfigId',
        name: 'home3rdFormDetail',
        component: () => import(/* webpackChunkName: "home3rdFormDetail" */ '../views/home3rd/formDetail.vue')
      },
      {
        path: '/home3rd/:spaceId/forms/:pageConfigId',
        name: 'home3rdForms',
        component: () => import(/* webpackChunkName: "home3rdForms" */ '../views/home3rd/forms.vue')
      },
      {
        path: '/home3rd/:spaceId/dataView/:pageConfigId',
        name: 'home3rdDataView',
        component: () => import(/* webpackChunkName: "home3rdDataView" */ '../views/home3rd/dataView.vue')
      },
      {
        path: '/home3rd/:spaceId/customHtml/:pageConfigId',
        name: 'home3rdHtml',
        component: () => import(/* webpackChunkName: "home3rdHtml" */ '../views/home3rd/customHtml.vue')
      },
      {
        path: '/home3rd/:spaceId/customTemp/:pageConfigId',
        name: 'home3rdTemp',
        component: () => import(/* webpackChunkName: "home3rdTemp" */ '../views/home3rd/customTemp.vue')
      },
      {
        path: '/home3rd/:spaceId/dashboard/:pageConfigId',
        name: 'home3rdDashboard',
        component: () => import(/* webpackChunkName: "home3rdDashboard" */ '../views/home3rd/dashboard.vue')
      },
      {
        path: '/home3rd/:spaceId/apps/:pageConfigId',
        name: 'home3rdApps',
        component: () => import(/* webpackChunkName: "home3rdApps" */ '../views/home/apps.vue')
      },
      {
        path: '/home3rd/:spaceId/mix_form/:pageConfigId',
        name: 'home3rdMixForm',
        component: () => import(/* webpackChunkName: "homeMixForm" */ '../views/mix_form/index.vue')
      },
      {
        path: '/home3rd/:spaceId/thirdPage/:pageConfigId',
        name: 'home3rdThirdPage',
        component: () => import(/* webpackChunkName: "home3rdThirdPage" */ '../views/home3rd/thirdPage.vue')
      },
      {
        path: '/home3rd/:spaceId/workStation/:pageConfigId',
        name: 'home3rdWorkStation',
        component: () => import(/* webpackChunkName: "home3rdWorkStation" */ '../views/home/workStation.vue')
      },
    ]
  },
  {
    path: '/single/mine/:pageConfigId',
    name: 'home3rdMineSingle',
    component: () => import(/* webpackChunkName: "home3rdMineSingle" */ '../views/home3rd/mine.vue')
  },
  {
    path: '/single/fillForm/:pageConfigId',
    name: 'home3rdFillFormSingle',
    component: () => import(/* webpackChunkName: "home3rdFillFormSingle" */ '../views/home3rd/fillForm.vue')
  },
  {
    path: '/single/todoTask/:pageConfigId',
    name: 'home3rdTodoTaskSingle',
    component: () => import(/* webpackChunkName: "home3rdTodoTaskSingle" */ '../views/home3rd/todoTask.vue')
  },
  {
    path: '/single/formDetail/:pageConfigId',
    name: 'home3rdFormDetailSingle',
    component: () => import(/* webpackChunkName: "home3rdFormDetailSingle" */ '../views/home3rd/formDetail.vue')
  },
  {
    path: '/single/forms/:pageConfigId',
    name: 'home3rdFormsSingle',
    component: () => import(/* webpackChunkName: "home3rdFormsSingle" */ '../views/home3rd/forms.vue')
  },
  {
    path: '/single/dataView/:pageConfigId',
    name: 'home3rdDataViewSingle',
    component: () => import(/* webpackChunkName: "home3rdDataViewSingle" */ '../views/home3rd/dataView.vue')
  },
  {
    path: '/single/customHtml/:pageConfigId',
    name: 'home3rdHtmlSingle',
    component: () => import(/* webpackChunkName: "home3rdHtmlSingle" */ '../views/home3rd/customHtml.vue')
  },
  {
    path: '/single/customTemp/:pageConfigId',
    name: 'home3rdTempSingle',
    component: () => import(/* webpackChunkName: "home3rdTempSingle" */ '../views/home3rd/customTemp.vue')
  },
  {
    path: '/single/customMixForm/:pageConfigId',
    name: 'home3rdMixFormSingle',
    component: () => import(/* webpackChunkName: "homeMixForm" */ '../views/mix_form/index.vue')
  },
  {
    path: '/flowList/:type',
    name: 'flowList',
    component: () => import(/* webpackChunkName: "flowList" */ '../views/flowList.vue')
  },
  {
    path: '/flow/todo',
    name: 'flowListTodo',
    meta: {
      title: '我的待办'
    },
    component: () => import(/* webpackChunkName: "homeWorkStation" */ '../views/home/todoHandle.vue')
  },
  {
    path: '/single/dashboard/:pageConfigId',
    name: 'home3rdDashboardSingle',
    component: () => import(/* webpackChunkName: "home3rdDashboardSingle" */ '../views/home3rd/dashboard.vue')
  },
  {
    path: '/file/preview',
    name: 'filePreview',
    meta: {
      title: '文件预览'
    },
    component: () => import(/* webpackChunkName: "filePreview" */ '../views/file/preview.vue')
  },
  {
    path: '/file/transit_preview',
    name: 'fileTransitPreview',
    meta: {
      title: '文件预览'
    },
    component: () => import(/* webpackChunkName: "fileTransitPreview" */ '../views/file/transit_preview.vue')
  },
  {
    path: '/mix_form/mix_form_list',
    name: 'mixFormList',
    component: () => import(/* webpackChunkName: "mixFormList" */ '../views/mix_form/mix_form_list.vue')
  },
  {
    path: '/mix_form/node_list',
    name: 'mixFormNodeList',
    component: () => import(/* webpackChunkName: "mixFormNodeList" */ '../views/mix_form/node_list.vue')
  },
  {
    path: '/mix_form/miniApp/node_list',
    name: 'mixFormMiniAppNodeList',
    component: () => import(/* webpackChunkName: "mixFormNodeList" */ '../views/mix_form/miniApp_node_list.vue')
  },
  {
    path: '/forward',
    name: 'forward',
    component: () => import(/* webpackChunkName: "forward" */ '../views/forward.vue')
  },
  {
    path: '/installTempForward',
    name: 'installTempForward',
    component: () => import(/* webpackChunkName: "installTempForward" */ '../views/installTempForward.vue')
  },
  {
    path: '/payment_gateway',
    name: 'payment_gateway',
    component: () => import(/* webpackChunkName: "payment_gateway" */ '../views/order/payment_gateway.vue')
  },
  {
    path: '/error',
    name: 'error',
    component: () => import(/* webpackChunkName: "error" */ '../views/error.vue')
  },
  {
    path: '/orderCenter',
    name: 'orderCenter',
    meta: {
      title: '订单中心'
    },
    component: () => import(/* webpackChunkName: "orderCenter" */ '../views/order/orderCenter.vue')
  },
  {
    path: '/orderQuery',
    name: 'orderQuery',
    meta: {
      title: '订单中心'
    },
    component: () => import(/* webpackChunkName: "orderQuery" */ '../views/order/orderQuery.vue')
  },
  {
    path: '/ymt',
    name: 'ymt',
    component: () => import(/* webpackChunkName: "ymt" */ '../views/ymt/index.vue'),
  },
  {
    path: '/share/ymt',
    name: 'shareYmt',
    component: () => import(/* webpackChunkName: "ymt" */ '../views/share/ymt.vue'),
  },
  {
    path: '/dataDrillDown',
    name: 'dataDrillDown',
    component: () => import(/* webpackChunkName: "ymt" */ '../views/dataDrillDown.vue'),
  },
  {
    path: '/showResource',
    name: 'showResource',
    component: () => import(/* webpackChunkName: "showResource" */ '../views/showResource.vue'),
  },
  {
    path: '/printer',
    name: 'printer',
    component: () => import(/* webpackChunkName: "showResource" */ '../views/printer.vue'),
  },
  {
    path: '/attDownload',
    name: 'attDownload',
    component: () => import(/* webpackChunkName: "showResource" */ '../views/attDownload.vue'),
  },
  {
    path: '/link/share/index',
    name: 'linkShare',
    component: () => import(/* webpackChunkName: "linkShare" */ '../views/link/share/index'),
    children: [
      {
        path: '/link/share/photo/:shareId',
        name: 'linkSharePhoto',
        meta: {
          title: '视图分享'
        },
        component: () => import(/* webpackChunkName: "linkSharePhoto" */ '../views/link/share/photo.vue')
      },
      {
        path: '/link/share/board/:shareId',
        name: 'linkShareBoard',
        meta: {
          title: '视图分享'
        },
        component: () => import(/* webpackChunkName: "linkShareBoard" */ '../views/link/share/board.vue')
      },
      {
        path: '/link/share/table/:shareId',
        name: 'linkShareTable',
        meta: {
          title: '视图分享'
        },
        component: () => import(/* webpackChunkName: "linkShareTable" */ '../views/link/share/table.vue')
      },

    ]
  },
  {
    path: '/account/disable',
    name:'AccountDisable',
    meta: {
      title: '账号已停用'
    },
    component: () => import('../views/accountStop.vue')
  }
]

const router = new VueRouter({
  routes
})
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(err => err)
}

export default router
